import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { ElectricityTransferPrices } from '@vae/server/dist/client'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface CompanySelectProps {
	selectedCompany: ElectricityTransferPrices | undefined
	companyList: ElectricityTransferPrices[] | undefined
	onCompanyChange: (companyName: string) => void
}

/**
 * CompanySelect component allows users to select an electricity company from a dropdown list.
 *
 * @param {CompanySelectProps} props - The props for the component.
 * @returns {JSX.Element} The rendered component.
 */
const CompanySelect: React.FC<CompanySelectProps> = ({
	selectedCompany,
	companyList,
	onCompanyChange,
}) => {
	const { t } = useTranslation('modals_contractOptions')

	return (
		<div className='input-container'>
			<FormControl fullWidth>
				<InputLabel>{t('electricityCompanyName')}</InputLabel>
				<Select
					MenuProps={{
						disablePortal: true,
						disableScrollLock: true,
						slotProps: {
							paper: {
								sx: {
									zIndex: 9999,
								},
							},
						},
					}}
					value={selectedCompany?.companyName ?? ''}
					onChange={e => onCompanyChange(e.target.value)}
					label={t('electricityCompanyName')}
				>
					{companyList?.map((company, index) => (
						<MenuItem key={index} value={company.companyName}>
							{company.companyName}
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</div>
	)
}

export default CompanySelect
